import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Domains } from '../../constants';
import { apiAliasToFrontendAlias } from '../alias/utils';
import { HasDependencies, hashString, Role, RoleId } from '../types';
import { handleGQLErrors } from '../utils';
import { DomainDependencies } from './types';

export interface DomainDependenciesService extends HasDependencies {
  get: (simulateRole: Role | null) => Promise<DomainDependencies | null>;
}

export class GraphQlDomainDependenciesService
  implements DomainDependenciesService
{
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly domain: Domains,
    readonly roleId: RoleId // The target for executorRoles
  ) {}

  public getDeps = () => [
    hashString([...this.graphQlRequestService.getDeps(), this.domain]),
  ];

  public get = async (simulateRole: Role | null) => {
    const result = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdkIgnoringErrors.domainDependencies({
        domain: this.domain,
        roleId: simulateRole?.id ?? this.roleId,
        domainFilter: this.domain,
        simulateRole: simulateRole?.id ?? null,
      })
    );
    const mappedResult = {
      ...result,
      executorRoles: result.listExecutorRolesForRole ?? [],
      domainInfo: {
        ...result.domainInfo,
        aliases:
          result.domainInfo?.aliases?.map((a) => apiAliasToFrontendAlias(a)) ??
          [],
      },
    };

    return mappedResult as DomainDependencies | null;
  };
}
